import { render, staticRenderFns } from "./underwriting.vue?vue&type=template&id=60d9b23f&scoped=true&"
import script from "./underwriting.vue?vue&type=script&lang=js&"
export * from "./underwriting.vue?vue&type=script&lang=js&"
import style0 from "./underwriting.vue?vue&type=style&index=0&id=60d9b23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d9b23f",
  null
  
)

export default component.exports